export function isBelyashiEggText(value) {
  return /беляши\s*с\s*мясом/i.test(String(value || ''))
}
